var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrganizations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "#FFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.418 4.532.207.006C12 4.662 13.75 6.783 13.75 9.153v.997c0 1.497-.75 2.745-1.875 3.618l3.375 2.494c.625.5 1 1.248 1 1.996v2.495C16.25 21.5 15.75 22 15 22H3.75C3 22 2.5 21.501 2.5 20.753v-2.37c0-.749.375-1.497 1-1.996l3.375-2.62C5.75 12.896 5 11.648 5 10.15V8.903c0-2.495 2.125-4.49 4.625-4.365zM14 3.789c.625-1.122 1.875-1.996 3.375-1.746S20 3.789 20 5.286v1.122c0 .874-.375 1.622-.875 2.12l2.25 1.498c.75.499 1.125 1.247 1.125 2.12v.998c0 .748-.5 1.247-1.25 1.247H17c0-.124-1.5-1.247-1.5-1.247.5-.873.75-1.996.75-3.118V8.778c0-1.995-.875-3.742-2.25-4.989z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizations);
export default __webpack_public_path__ + "static/media/organizations.6a010db0ded8ed6eeb269b93762cc729.svg";
export { ForwardRef as ReactComponent };